// Geometry is kept separate so every focused arrangement can be checked for overlap.
// The gallery holds a variable number of photographs per category. Unselected, they
// flow as a close-packed column masonry; selecting one gives it a feature block across
// the top and reflows the rest beneath it.
function computePortfolioLayout(width, category, selected, ratios, mobile) {
  const count = ratios.length;
  const rects = new Array(count);
  if (!count) return {height: 0, rects};

  const columns = mobile ? 2 : 3;
  const gap = mobile ? 14 : width < 900 ? 16 : 20;
  const rowGap = mobile ? 30 : 32;
  const columnWidth = (width - gap * (columns - 1)) / columns;
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  const rect = (x, y, w, h) => ({x, y, width: w, height: h});

  // Heights follow each photograph's own proportions, held inside an editorial range
  // so one very tall or very wide frame cannot run away with the column.
  const tileHeight = ratio => clamp(columnWidth / ratio, columnWidth * .72, columnWidth * 1.5);

  // Always place into the shortest column, which keeps the bottom edge close to level.
  function flow(indexes, startY) {
    const columnY = new Array(columns).fill(startY);
    for (const index of indexes) {
      let column = 0;
      for (let i = 1; i < columns; i++) if (columnY[i] < columnY[column] - 0.5) column = i;
      const height = tileHeight(ratios[index]);
      rects[index] = rect(column * (columnWidth + gap), columnY[column], columnWidth, height);
      columnY[column] += height + rowGap;
    }
    return columnY.reduce((a, b) => Math.max(a, b), startY) - rowGap;
  }

  const others = [];
  for (let i = 0; i < count; i++) if (i !== selected) others.push(i);

  if (selected < 0 || selected >= count) {
    return {height: Math.max(0, flow(others, 0)), rects};
  }

  if (mobile) {
    const focusHeight = clamp(width / ratios[selected], width * .66, width * 1.25);
    rects[selected] = rect(0, 0, width, focusHeight);
    return {height: Math.max(focusHeight, flow(others, focusHeight + rowGap)), rects};
  }

  // Desktop: the selected photograph spans two columns, with up to two others stacked
  // beside it in the third, and everything remaining flowing underneath.
  const focusWidth = columnWidth * 2 + gap;
  const focusHeight = clamp(focusWidth / ratios[selected], columnWidth * 1.15, columnWidth * 1.95);
  rects[selected] = rect(0, 0, focusWidth, focusHeight);

  const sideX = focusWidth + gap;
  const beside = others.slice(0, 2);
  if (beside.length === 2) {
    const sideHeight = (focusHeight - rowGap) / 2;
    rects[beside[0]] = rect(sideX, 0, columnWidth, sideHeight);
    rects[beside[1]] = rect(sideX, sideHeight + rowGap, columnWidth, sideHeight);
  } else if (beside.length === 1) {
    rects[beside[0]] = rect(sideX, 0, columnWidth, focusHeight);
  }

  const bottom = flow(others.slice(2), focusHeight + rowGap);
  return {height: Math.max(focusHeight, bottom), rects};
}

if (typeof module !== 'undefined' && module.exports) module.exports = {computePortfolioLayout};
